import { render, staticRenderFns } from "./AsignacionesConvenio.vue?vue&type=template&id=4fc22d44"
import script from "./AsignacionesConvenio.vue?vue&type=script&lang=js"
export * from "./AsignacionesConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports